var map = {
	"./API/ApiTokenManager": [
		68186,
		8186
	],
	"./API/ApiTokenManager.vue": [
		68186,
		8186
	],
	"./API/Index": [
		55125,
		5125
	],
	"./API/Index.vue": [
		55125,
		5125
	],
	"./Admin/Accounts": [
		46101,
		6101
	],
	"./Admin/Accounts/": [
		46101,
		6101
	],
	"./Admin/Accounts/index": [
		46101,
		6101
	],
	"./Admin/Accounts/index.vue": [
		46101,
		6101
	],
	"./Admin/Accounts/show": [
		53358,
		3358
	],
	"./Admin/Accounts/show.vue": [
		53358,
		3358
	],
	"./Admin/Customer/Index": [
		31060,
		1060
	],
	"./Admin/Customer/Index.vue": [
		31060,
		1060
	],
	"./Admin/Customer/Show": [
		69175,
		9175
	],
	"./Admin/Customer/Show.vue": [
		69175,
		9175
	],
	"./Admin/Dashboard": [
		20067,
		67
	],
	"./Admin/Dashboard.vue": [
		20067,
		67
	],
	"./Admin/DiyOrder/Index": [
		11975,
		1975
	],
	"./Admin/DiyOrder/Index.vue": [
		11975,
		1975
	],
	"./Admin/KutesmartOrder/Index": [
		10728,
		728
	],
	"./Admin/KutesmartOrder/Index.vue": [
		10728,
		728
	],
	"./Admin/Marketing/Index": [
		21424,
		1424
	],
	"./Admin/Marketing/Index.vue": [
		21424,
		1424
	],
	"./Admin/MccOrder/Index": [
		98791,
		8791
	],
	"./Admin/MccOrder/Index.vue": [
		98791,
		8791
	],
	"./Admin/Orders/Index": [
		7121,
		7121
	],
	"./Admin/Orders/Index.vue": [
		7121,
		7121
	],
	"./Admin/Orders/Partials/Address": [
		13110,
		3110
	],
	"./Admin/Orders/Partials/Address.vue": [
		13110,
		3110
	],
	"./Admin/Orders/Partials/TotalRow": [
		80918,
		918
	],
	"./Admin/Orders/Partials/TotalRow.vue": [
		80918,
		918
	],
	"./Admin/Orders/Partials/subTitle": [
		42465,
		2465
	],
	"./Admin/Orders/Partials/subTitle.vue": [
		42465,
		2465
	],
	"./Admin/Orders/Show": [
		44720,
		4720
	],
	"./Admin/Orders/Show.vue": [
		44720,
		4720
	],
	"./Auth/Login": [
		30562,
		562
	],
	"./Auth/Login.vue": [
		30562,
		562
	],
	"./Auth/Register": [
		17546,
		7546
	],
	"./Auth/Register.vue": [
		17546,
		7546
	],
	"./Auth/RegistrationComplete": [
		96667,
		6667
	],
	"./Auth/RegistrationComplete.vue": [
		96667,
		6667
	],
	"./Auth/ResetPassword": [
		13936,
		3936
	],
	"./Auth/ResetPassword.vue": [
		13936,
		3936
	],
	"./Auth/ResetPasswordForm": [
		72779,
		2779
	],
	"./Auth/ResetPasswordForm.vue": [
		72779,
		2779
	],
	"./Collections/Index": [
		3228,
		5473
	],
	"./Collections/Index.vue": [
		3228,
		5473
	],
	"./Customer/Design": [
		1634,
		1634
	],
	"./Customer/Design.vue": [
		1634,
		1634
	],
	"./Customer/Index": [
		80126,
		126
	],
	"./Customer/Index.vue": [
		80126,
		126
	],
	"./Customer/Show": [
		25354,
		5354
	],
	"./Customer/Show.vue": [
		25354,
		5354
	],
	"./Dashboard": [
		31768,
		1768
	],
	"./Dashboard.vue": [
		31768,
		1768
	],
	"./DiscountCodes/Index": [
		41387,
		1387
	],
	"./DiscountCodes/Index.vue": [
		41387,
		1387
	],
	"./Marketing/Index": [
		65356,
		5356
	],
	"./Marketing/Index.vue": [
		65356,
		5356
	],
	"./Orders/Design": [
		65506,
		5506
	],
	"./Orders/Design.vue": [
		65506,
		5506
	],
	"./Orders/Index": [
		50011,
		11
	],
	"./Orders/Index.vue": [
		50011,
		11
	],
	"./Orders/Partials/Address": [
		23753,
		3753
	],
	"./Orders/Partials/Address.vue": [
		23753,
		3753
	],
	"./Orders/Partials/TotalRow": [
		76863,
		6863
	],
	"./Orders/Partials/TotalRow.vue": [
		76863,
		6863
	],
	"./Orders/Partials/subTitle": [
		33314,
		3314
	],
	"./Orders/Partials/subTitle.vue": [
		33314,
		3314
	],
	"./Orders/Show": [
		65800,
		5800
	],
	"./Orders/Show.vue": [
		65800,
		5800
	],
	"./Profile/DeleteUserForm": [
		40533,
		533
	],
	"./Profile/DeleteUserForm.vue": [
		40533,
		533
	],
	"./Profile/LogoutOtherBrowserSessionsForm": [
		55447,
		5447
	],
	"./Profile/LogoutOtherBrowserSessionsForm.vue": [
		55447,
		5447
	],
	"./Profile/Show": [
		90537,
		537
	],
	"./Profile/Show.vue": [
		90537,
		537
	],
	"./Profile/TwoFactorAuthenticationForm": [
		46782,
		6782
	],
	"./Profile/TwoFactorAuthenticationForm.vue": [
		46782,
		6782
	],
	"./Profile/UpdatePasswordForm": [
		79229,
		9229
	],
	"./Profile/UpdatePasswordForm.vue": [
		79229,
		9229
	],
	"./Profile/UpdateProfileInformationForm": [
		20385,
		385
	],
	"./Profile/UpdateProfileInformationForm.vue": [
		20385,
		385
	],
	"./SuitbuilderOptions/Index": [
		83078,
		3078
	],
	"./SuitbuilderOptions/Index.vue": [
		83078,
		3078
	],
	"./Tailor/Show": [
		32141,
		2141
	],
	"./Tailor/Show.vue": [
		32141,
		2141
	],
	"./Vendors/Index": [
		74295,
		4295
	],
	"./Vendors/Index.vue": [
		74295,
		4295
	],
	"./Widget/Index": [
		48114,
		8114
	],
	"./Widget/Index.vue": [
		48114,
		8114
	],
	"./Widget/Partirals/widgetStep": [
		86816,
		6816
	],
	"./Widget/Partirals/widgetStep.vue": [
		86816,
		6816
	],
	"./YourPricing/Index": [
		46202,
		6202
	],
	"./YourPricing/Index.vue": [
		46202,
		6202
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 74985;
module.exports = webpackAsyncContext;